module.exports = __webpack_public_path__ + "static/media/menuLunch.01284271.png";